import { useUser } from '@clerk/clerk-react';
import { Navigate, useLocation } from '@tanstack/react-router';

const PublicRoute = ({ children }) => {
    const { isSignedIn, isLoaded } = useUser();
    const location = useLocation();

    if (isLoaded && isSignedIn) {
        const { pathname } = location;

        if (pathname.startsWith('/cover-course/')) {
            const slug = pathname.split('/')[2];
            if (slug) {
                return <Navigate to="/course/$courseSlug" params={{ courseSlug: slug }} replace />;
            }
        }

        if (pathname === '/available-courses') {
            return <Navigate to="/explore-courses" replace />;
        }
        if (pathname === '/sign-in' || pathname === '/sign-up') {
            return <Navigate to="/dashboard" replace />;
        }
    }

    return children;
};

export default PublicRoute;
